<template>
  <div>
    <div>12313123123123212132</div>
    <div>{{cookieb}}-----</div>
    <div>{{cookieb.mId}}----------</div>
    <!-- <button @click="showcookie">ddd</button> -->
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { Toast } from 'mint-ui';
import $ from "jquery";
let Base64 = require('js-base64').Base64;

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '',
      cookieb:'',
      msg2: [],
      imgurl:'',
    }
  },
  methods:{
    // showcookie(){
    //   this.msg=document.cookie;
    //   var req = new XMLHttpRequest();
    //   req.open('GET', 'https://qahkapi.qdingnet.com/qding-hk/app-h5/index.html', false);
    //   req.send(null);
    //   var headers = req.getAllResponseHeaders().toLowerCase();
    //   this.msg2=headers
    // },
    getcookie(name){
            var that = this;　　　　
            //检查这个cookie是否存在，不存在就为 -1
            let c_start = document.cookie.indexOf(name + "=")
            if (c_start != -1) {
                //获取cookie值的开始位置
                c_start = c_start + name.length + 1;
               
                //通过";"号是否存在来判断结束位置
                let c_end = document.cookie.indexOf(";", c_start);

                if (c_end == -1){
                    c_end = document.cookie.length;
                }
                //通过substring()得到了值
                this.cookieb = unescape(document.cookie.substring(c_start, c_end))
                this.cookieb=Base64.decode(this.cookieb)
                this.cookieb= JSON.parse(this.cookieb);
            }　　　　　　　　
        
        }
  },
  mounted:function(){
    this.getcookie('X');
    
  }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#capture{
  height: 650px;
  border: 10px solid rebeccapurple;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue